import {theme} from "../../../../../_fri/themes/theme";
import {CustomDetailBodyResume} from "../../../../../_fri/components/CustomDetailBodyResume/CustomDetailBodyResume";
import {CustomItemDetailBody} from "../../../../../_fri/components/CustomItemDetailBody/CustomItemDetailBody";
import {TextField} from "@mui/material";
import Box from "@mui/material/Box/Box";
import {EcommerceDashboardDetailBodyPayment} from "./EcommerceDashboardDetailBodyPayment";
import {useInputNumberHook} from "../../../../../_fri/hooks/useInputNumberHook";

export const EcommerceDashboardDetailBody = () => {
    const [valuePayment, handleValuePayment]= useInputNumberHook('600.00');
    return (
        <Box sx={{
            border: `1px ${theme.palette.common.black} solid`,
            borderRadius: "1.8rem",
            padding: "1rem",
            margin: "2rem",
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            marginBottom: "1rem",
            fontWeight: theme.typography.fontWeightLight,
            fontSize: "1rem"
        }}>
            <CustomDetailBodyResume type={'la compra'} resume={'Televisor Led, Estufa a gas'}/>
            <CustomItemDetailBody sx={{marginTop: "1.5rem"}} title={"Subtotal:"} detail={<>GTQ 600.00</>}/>
            <CustomItemDetailBody sx={{marginTop: "0.6rem"}} title={"Descuento:"} detail={<>GTQ 0.00</>}/>
            <CustomItemDetailBody sx={{marginTop: "0.6rem"}} title={"Total (GTQ):"}
                                  detail={<TextField size={"small"} onChange={e=> handleValuePayment(e.target.value)} value={valuePayment} variant="outlined"/>}/>

            <EcommerceDashboardDetailBodyPayment valuePayment={valuePayment}/>
        </Box>
    );
};